//
export const watch = {
  active(value) {
    if (value === true) {
      this.updateData()
    }
  }
}
